var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tableHead",staticClass:"table-head",style:(_vm.TableHeadWidth)},[_c('div',{ref:"thead",staticClass:"table"},[_c('div',{staticClass:"thead"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }